/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetailerConfirmationDto
 */
export interface RetailerConfirmationDto {
    /**
     * Retailer decision on the supplier-driven changes. ACCEPTED → order moves to PROCESSING with the new totals. REJECTED → order is CANCELED.
     * @type {string}
     * @memberof RetailerConfirmationDto
     */
    decision: RetailerConfirmationDtoDecisionEnum;
    /**
     * Optional notes recorded with the confirmation (phone-call summary for admin-on-behalf, free text for retailer self-confirmations).
     * @type {string}
     * @memberof RetailerConfirmationDto
     */
    notes?: string;
}


/**
 * @export
 */
export const RetailerConfirmationDtoDecisionEnum = {
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED'
} as const;
export type RetailerConfirmationDtoDecisionEnum = typeof RetailerConfirmationDtoDecisionEnum[keyof typeof RetailerConfirmationDtoDecisionEnum];


/**
 * Check if a given object implements the RetailerConfirmationDto interface.
 */
export function instanceOfRetailerConfirmationDto(value: object): value is RetailerConfirmationDto {
    if (!('decision' in value) || value['decision'] === undefined) return false;
    return true;
}

export function RetailerConfirmationDtoFromJSON(json: any): RetailerConfirmationDto {
    return RetailerConfirmationDtoFromJSONTyped(json, false);
}

export function RetailerConfirmationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerConfirmationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'decision': json['decision'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function RetailerConfirmationDtoToJSON(value?: RetailerConfirmationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'decision': value['decision'],
        'notes': value['notes'],
    };
}

